import { render, staticRenderFns } from "./PlacementTests.vue?vue&type=template&id=891a888e&"
import script from "./PlacementTests.vue?vue&type=script&lang=js&"
export * from "./PlacementTests.vue?vue&type=script&lang=js&"
import style0 from "./PlacementTests.vue?vue&type=style&index=0&id=891a888e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports